<script setup>
const props = defineProps({
  label: String,
  value: Number,
  color: String // 'accent' | 'muted' | 'destructive'
})

const colorClasses = {
  accent: 'bg-accent/60',
  muted: 'bg-muted-foreground/40',
  destructive: 'bg-destructive/60',
};
</script>

<template>
  <div>
    <div class="flex justify-between text-xs mb-1">
      <span class="text-muted-foreground">{{ label }}</span>
      <span class="text-foreground">{{ value }}%</span>
    </div>
    <div class="h-2 rounded-full bg-background/80 overflow-hidden">
      <div 
        :class="['h-full rounded-full transition-all duration-700', colorClasses[color]]"
        :style="{ width: `${value}%` }"
      />
    </div>
  </div>
</template>
